import { Injectable, TemplateRef } from '@angular/core';
import { BaseControl, Textbox, Custom, PermisosTipoDocumental } from '@app/shared';
import { Validators } from '@angular/forms';
import {
  ClasificacionPredeterminada
} from '@app/shared';

@Injectable()
export class DocumentPermissionsFormService {

  constructor() { }

  /**
   * Construye y retorna el formulario para agregar o modificar la clasificación de un documento
   *
   * @param {TemplateRef<any>} templateUpload
   * @param {PermisosTipoDocumental} [documentPermission]
   * @returns {BaseControl<any>[]}
   * @memberof DocumentPermissionsFormService
   */
  getFormDocumentPermissions(
    templetesFomr: any,
    options: any,
    data: any,
    groupSelect?: any,
    documentPermission?: PermisosTipoDocumental,
  ): BaseControl<any>[] {
    const controls: BaseControl<any>[] = [
      new Custom({
        key: 'cboGroup',
        label: 'Grupo',
        order: 2,
        template: templetesFomr,
        placeholder: 'Seleccione el grupo',
        value: groupSelect ? groupSelect : null,
        options: options ? options : [],
        validations: {
          validators: [Validators.required]
        },
      }),
      // new Textbox({
      //   key: 'rol',
      //   type: 'text',
      //   label: 'Rol',
      //   order: 1,
      //   size: 'col-12',
      //   value: documentPermission.rol ? documentPermission.rol.nombre : null,
      //   modifiable: false,
      //   readonly: true
      // }),
      // new Textbox({
      //   key: 'consulta',
      //   type: 'checkbox',
      //   label: 'Consulta',
      //   order: 3,
      //   size: 'col-12',
      //   value: documentPermission ? documentPermission.consulta : false
      // })
    ];
    if(data != {}){
      if(data['tipo'] == "serie"){
        controls.push(new Textbox({
          key: 'tipo',
          type: 'text',
          label: 'Serie',
          order: 1,
          size: 'col-12',
          value: data['valor'] ? data['valor'] : null,
          modifiable: false,
          readonly: true
        })) 
      }else if(data['tipo'] == "subserie"){
        controls.push(new Textbox({
          key: 'tipo',
          type: 'text',
          label: 'SubSerie',
          order: 1,
          size: 'col-12',
          value: data['valor'] ? data['valor'] : null,
          modifiable: false,
          readonly: true
        })) 
      }else if(data['tipo'] == "tipo_documental"){
        controls.push(new Textbox({
          key: 'tipo',
          type: 'text',
          label: 'Tipo documental',
          order: 1,
          size: 'col-12',
          value: data['valor'] ? data['valor'] : null,
          modifiable: false,
          readonly: true
        })) 
      }
      
    }

    return controls.sort((a, b) => a.order - b.order);
  }

}



// WEBPACK FOOTER //
// ./src/app/administration/documents/document-permissions/shared/document-permissions-form.service.ts